import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const NotFound = ({ location }) => {
  return (
    <>
      <Helmet>
        <title>Not Found</title>
      </Helmet>
      <div className="mx-1">
        <h2>404: This page does not seem to exist…</h2>
        <p className="lead">
          We couldn&apos;t find a page at <code>{location.pathname}</code>.
          Check the URL for any typos or head to the{' '}
          <Link to="/">homepage</Link>.
        </p>
      </div>
    </>
  )
}

NotFound.propTypes = {
  location: PropTypes.object.isRequired,
}

export default NotFound
